import axios from "axios";

export const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: API_URL });

export const rupees = (paise) =>
  `₹${(paise / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const rupeesPerSachet = (paise, sachets) =>
  `₹${Math.round(paise / sachets / 100).toLocaleString("en-IN")}`;

export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
